import React from "react";
import { useHistory } from "react-router-dom";
import Menu from "@components/Menu";

import {
  MdCheckBox,
} from "react-icons/md";

import "./type.css";

const documentTypes = [
  {
    id: "jscm",
    title: "Jogos Santa Casa da Misericórdia",
    description: "Registar um novo pagamento JSCM",
    icon: <img src="https://eposgestofinal.com/site/images/jscm.png" alt="" style={{ width: '40px' }} />,
  },
  {
    id: "providers",
    title: "Fornecedores",
    description: "Registar um novo pagamento a fornecedor",
    icon: <MdCheckBox />,
    color: "bg-info",
    bgColor: "#5bc0de",
    comingSoon: false,
  },
];

function App() {
  const history = useHistory();

  const handleSelectDocument = (docType) => {
    history.push("/payments/new/" + docType.id);
  };

  return (
    <div>
      <Menu />
      <div className="fullContainer" style={{ maxWidth: "100%" }}>
        <div className="col-xs-12">
          <ol
            style={{
              textAlign: "left",
              marginTop: "75px",
            }}
            className="breadcrumb"
          >
            <li>
              <a href="http://eposgestofinal.com/index.php">Portal</a>
            </li>
            <li>
              <a href="/payments">Pagamentos</a>
            </li>
            <li className="active">
              <span>Novo Registo</span>
            </li>
          </ol>
        </div>
      </div>
      <div className="fullContainer sales-type">
        <div className="row">
          <div className="col-xs-12 text-center">
            <h1 className="page-header">Registo de Pagamento</h1>
            <p className="lead">
              Selecione o tipo de pagamento que deseja registar
            </p>
          </div>
        </div>

        <div className="row">
          {documentTypes.map((docType) => (
            <div key={docType.id} className="col-sm-6 col-md-4">
              <div
                className={`panel panel-default document-card ${
                  docType.comingSoon ? "disabled" : ""
                }`}
                onClick={() => handleSelectDocument(docType)}
                style={{
                  cursor: docType.comingSoon ? "not-allowed" : "pointer",
                  opacity: docType.comingSoon ? 0.5 : 1,
                }}
              >
                <div className="panel-body">
                  <div className="media">
                    <div className="media-left">
                      <div
                        className="icon-container"
                        style={{ backgroundColor: docType.bgColor }}
                      >
                        {docType.icon}
                      </div>
                    </div>
                    <div className="media-body">
                      <h4 className="media-heading">
                        {docType.title}
                        {docType.comingSoon && (
                          <small className="text-muted"> (Brevemente)</small>
                        )}
                      </h4>
                      <p>{docType.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
